<template>
<div>
    <smallbutton toplabel="Add Reservation" @click="startUpdate()" v-if="isNew"/>
    <linkbutton toplabel="Update" @click="startUpdate()" v-if="!isNew"/>

    <!-- MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <form id="updateguestform" ref="updateguestform" @submit.prevent v-if="ticket!=null">
                <label class="titlelabel">{{ title }}</label>

                <div class="margin10">
                    <label>{{ seatingMessage }}</label>
                </div>
                
                <formentry label="Guest Name" isrequired='True' v-model="ticket.TakeOutGuestName" />
                <formentry label="Guest Count" isrequired='True' v-model="ticket.guestCount"  />
               
                <formentry label="Phone" inputtype="tel" isrequired="True" @blur="leavePhone" v-model="ticket.guestPhone"/> 

                <smallbutton  @click="save()" toplabel="Save" />
                <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Cancel"/>
                <div>
                    <label class="responsemessage">{{responseMessage}}</label>
                </div>
            </form>
            
        </template>
      </actionmodal>
    </div>
</template>

<script>
import datamethods from '../../services/datamethods'
import format from '../../style/format'
import smallbutton from '../controls/button.vue'
import actionmodal from '../controls/actionmodal.vue'
import formentry from '../controls/entry.vue'
import linkbutton from '../controls/linkbutton.vue'
import pencilbutton from '../controls/pencilbutton.vue'
export default {
    name:'updatereservation',
    components:{
        smallbutton,
        actionmodal,
        formentry,
        linkbutton,
        pencilbutton
    },
    mixins:[datamethods,format],
    props:{
        reservationTicket:{
            type:Object,
        },
        isNew:{
            type:Boolean,
            default:false
        },
        seating:{
            type:Object,
            required:true
        },
        businessDayId:{
            type:Number,
            required:true
        },
        terminalId:{
            type:Number,
            required:true
        }
        
    },
    
    data(){
        return{
            responseMessage:'',
            ticket:null,
            originalGuestCount:0
            
        }
    },
    computed:{
           
            seatingMessage(){
                var msg = null
               if(this.seating==null){
                    msg="The date and seating selected is not available for reservations."
                }else{
                    msg="There are " + this.seating.seatsAvailable + " seats available"
                }
                return msg
            },
            title(){
                var msg = 'Add Reservation for '
                msg= msg + this.seating.name
                return msg
            }
            
        },
    methods:{
       
        async startUpdate(){

            this.responseMessage = ''


            if(this.isNew){
                this.ticket={
                    id:0,
                    TakeOutGuestName:null,
                    guestCount:1,
                    guestPhone:null,
                    seatingId:this.seating.id,
                    startDateTime:this.seating.seatingDateTime,
                    businessDayId:this.businessDayId,
                    terminalId:this.terminalId

                }
                this.originalGuestCount=0
                
            }else{
            
                this.ticket=this.reservationTicket
                this.originalGuestCount=this.ticket.guestCount
                this.ticket.TakeOutGuestName=this.ticket.guestName
            }
            this.$refs.mymodal.openModal()
           

        },
     
        async save(){
            if(this.$refs.updateguestform.checkValidity()==false){
                this.responseMessage="Please fill in all of the required fields "
                return}

            if(this.isNew)    {
                if(this.ticket.guestCount> this.seating.seatsAvailable ){
                    this.responseMessage="Please enter a guest count less than or equal to " + this.seating.seatsAvailable
                    return
                }
            }
            
            this.ticket.guestPhone=this.$options.filters.cleanPhone(this.ticket.guestPhone)

            let req = {
                ticket:this.ticket
            }
            var response 
            if(this.isNew){
                response=await this.callAPI(req,'addticket')
            }else{
                req.originalGuestCount=this.originalGuestCount
                response=await this.callAPI(req, 'ticket_savereservation')
            }
            if(response.Successful){
                this.$emit('refresh')
                this.$refs.mymodal.closeModal()
          
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;
        },
        
        leavePhone(){

            this.ticket.guestPhone=this.$options.filters.formatPhone(this.ticket.guestPhone);
            
            
        },
       
    }
}
</script>

<style>
.entryCheckLabel{
    margin:0px 0px 0px 5px;
    font-size:medium;
    text-align: left;  
    max-width: 420px;
}
.entryCheckLabelbold{
    margin:0px 0px 0px 5px;
    font-size:medium;
    text-align: left;  
    max-width: 420px;
    font-weight:bold;
}
</style>





























